module.exports = __webpack_public_path__ + "img/commission_phone.3aeffa84.svg";